export default __webpack_public_path__ + "static/10-037d8f260d0d4d3407a3b4500899d1e4.png";